import { InjectionToken, Provider } from '@angular/core';

export interface AuthApiConfig {
  readonly baseUrl: string;
  readonly clientId: string;
  readonly clientSecret: string;
}

export const AUTH_API_CONFIG = new InjectionToken<AuthApiConfig>('AUTH_API_CONFIG');

export function provideAuthApiConfig(config: AuthApiConfig): Provider {
  return { provide: AUTH_API_CONFIG, useValue: config };
}
